
import { defineComponent } from 'vue'
import Level from '@/components/Level.vue'
import ArrowButton from '@/components/ArrowButton.vue'

export default defineComponent({
  name: 'TPSlider',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    size: String,
    icon: {
      type: String,
      default: '',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
  },
  components: {
    'tp-arrow-button': ArrowButton,
    'tp-level': Level,
  },
  data: function () {
    return {
      currentTask: {} as any,
      items: [] as any,
      index: 0,
    }
  },
  mounted: function () {
    this.items = this.$store.getters.targets
    this.setTaskByIndex('6')
  },
  methods: {
    theRandomTask: function (): void {
      this.index = Math.floor(Math.random() * this.items.length)
      this.setTaskByIndex(this.index.toString())
    },
    startRandomTask() {
      this.theRandomTask()
      this.$store.dispatch('setGameStatus', true)

      //@ts-ignore
      if (window.ta) {
        //@ts-ignore
        ta('specials.2048.startGame', 1, {
          gameTitle: this.$store.getters.target.title || 'empty',
          gameStartSource: 'random',
        })
      }

      this.$router.push('/game')
    },
    setTaskByIndex: function (index: string): void {
      let newIndex = 0
      if (parseInt(index) >= this.items.length) {
        this.currentTask = this.items[0]
        this.index = 0
      } else if (parseInt(index) < 1) {
        newIndex = this.items.length - 1
        this.currentTask = this.items[newIndex]
        this.index = newIndex
      } else {
        newIndex = parseInt(index)
        this.currentTask = this.items[newIndex]
        this.index = newIndex
      }

      this.$store.dispatch('setTarget', newIndex)
    },
    next: function (): void {
      const index = this.index + 1
      this.setTaskByIndex(index.toString())
    },
    prev: function (): void {
      const index = this.index - 1
      this.setTaskByIndex(index.toString())
    },
  },
  computed: {
    html(): string {
      let title = this.currentTask.html || this.currentTask.title

      return title
    },
    level(): Number {
      return this.currentTask.level || 1
    },
  },
})
